import { render, staticRenderFns } from "./IconCollect.vue?vue&type=template&id=777bdbc1&scoped=true&"
import script from "./IconCollect.vue?vue&type=script&lang=js&"
export * from "./IconCollect.vue?vue&type=script&lang=js&"
import style0 from "./IconCollect.vue?vue&type=style&index=0&id=777bdbc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777bdbc1",
  null
  
)

export default component.exports